import { Suspense }  from 'react';
import  { BrowserRouter, Routes, Route } from 'react-router-dom'
import './App.css';

import MainPage from '../src/pages/MainPage.js'
import TrackPage from '../src/pages/TrackPage.js'
import TrackDetailPage from '../src/pages/TrackDetailPage.js'
import InformPage from '../src/pages/InformPage.js'
import NewInformPage from '../src/pages/NewInformPage.js'
import SummaryPage from '../src/pages/SummaryPage.js'
import PricePage from '../src/pages/SummaryPage.js';
import ErrorPage from '../src/pages/ErrorPage.js';
import HelpSuccessPage from '../src/pages/HelpSuccessPage.js';
import AdditionalDocument from '../src/pages/additionalDocument.js';


function App() {
  return (
  <Suspense  fallback="loading">
    <BrowserRouter>
      <Routes>

        <Route exact path="/" element={<MainPage />} />

        <Route exact path="/track" element={<TrackPage />} />
        <Route exact path="/track/detail" element={<TrackDetailPage />} />

        <Route exact path='/inform' element={<InformPage />} />
        <Route exact path='/inform/new' element={<NewInformPage />} />
        <Route exact path='/inform/additional/:referenceNo' element={<AdditionalDocument />} />

        <Route exact path='/summary' element={<SummaryPage />} />
        
        <Route exact path='/price' element={<PricePage />} />

        <Route exact path='/error' element={<ErrorPage />} />
        <Route exact path='/helpsuccess' element={<HelpSuccessPage />} />
        
      </Routes>
    </BrowserRouter>
  </Suspense>

  );
}

export default App;
